import {Grid, Skeleton, Stack} from "@mui/material";

export interface BmInfoCardSkeletonProps {
  items?: number;
}

export const BmInfoCardSkeleton: React.FC<BmInfoCardSkeletonProps> = ({items = 2}) => {
  return (
    <Grid container spacing={4}>
      {Array.from({length: items}).map((_, index) => (
        <Grid key={index} item xs={12} md={6} lg={3}>
          <Stack spacing={2}>
            <Skeleton variant="rounded" height={10} sx={{flex: 1, borderRadius: 2}} />
            <Skeleton variant="rounded" height={40} sx={{flex: 1, borderRadius: 2}} />
            <Skeleton variant="rounded" height={40} sx={{flex: 1, borderRadius: 2}} />
          </Stack>
        </Grid>
      ))}
    </Grid>
  );
};
